export default {
  mitigationGroups: [],
  loading: false
}
